import { Col, Row, Alert } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { contains, openNewTab, parseErrorMessage, isEmptyObj } from "utils";
import { toast } from "Layout/slice";
import PlanCard from "shared/PlanCard";
import { Loader } from "components/Loader";
import { Button } from "components/Button";
import {
  billingHistoryColumns,
  //  surmountFeatureColumns
} from "../columns";
import { userDetailSelect } from "Layout/slice/selector";
// import { HistoryMobileCard } from "./HistoryMobileCard";
import { PlanAndBillingContainer } from "./PlanAndBilling.styles";
import { updatePaymentMethod } from "../PurchasePlan/service";
import { Table } from "components/Table";
import { togglePurchasePlanModal } from "Layout/slice/index";
import {
  useBillingHistory,
  // usePlanRevision
} from "features/Account/hook";

export const PlanAndBilling = () => {
  const dispatch = useDispatch();
  const user = useSelector(userDetailSelect);
  const [isFetching, setIsFetching] = useState(false);

  // const { isLoading: isPlanLoading, planRevision } = usePlanRevision();

  const {
    isLoading: isBillHistoryLoading,
    isFetchingNextPage,
    billingHistory,
    totalPages: totalBillingPages,
    totalCount: totalHistory,
    currentPage: historyActivePage,
    fetchNextPage,
    hasNextPage,
  } = useBillingHistory();

  const handleOpenInvoice = (url) => {
    if (!url || url === "No invoice") {
      dispatch(
        toast({
          type: "error",
          body: "No invoice found",
        })
      );
    } else {
      openNewTab(url);
    }
  };

  const handleUpdateClick = async () => {
    setIsFetching(true);
    try {
      const { url } = await updatePaymentMethod();
      openNewTab(url, "_self");
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    } finally {
      setIsFetching(false);
    }
  };

  const handleButtonClick = () => {
    if (
      contains(user?.surmount_plan?.name, "Premium") &&
      user?.payment_failed
    ) {
      handleUpdateClick();
      return;
    }
    dispatch(togglePurchasePlanModal(true));
  };

  const getButtonLabel = () => {
    let buttonText = "Available Plans";
    if (contains(user.surmount_plan.name, "Free")) {
      buttonText = "Get Premium";
    } else if (
      contains(user?.surmount_plan?.name, "Premium") &&
      user?.payment_failed
    ) {
      buttonText = "Update payment method";
    }
    return buttonText;
  };

  // const handleLoadMoreHistoryClick = () => {
  //   if (hasNextPage) {
  //     fetchNextPage();
  //   }
  // };

  const handlePageChange = (newPage) => {
    if (newPage > historyActivePage && hasNextPage) {
      fetchNextPage();
    }
  };

  return (
    <PlanAndBillingContainer>
      {/* Current Plan */}

      <div className="plan-wrapper">
        <Row>
          <Col xl={12} lg={12} xs={12} md={12} className="p-0">
            {user?.modifying && (
              <Alert>New plan details will be updated soon!</Alert>
            )}
            {user && !isEmptyObj(user.surmount_plan) ? (
              <>
                <PlanCard />
                {/* <div className="feature-table-wrapper">
                  <Table
                    isLoading={isPlanLoading}
                    columns={surmountFeatureColumns}
                    data={planRevision}
                    showPagination={false}
                  />
                </div> */}
              </>
            ) : (
              <div>No plan purchased yet</div>
            )}

            {!user?.dummy_premium && (
              <Button className="mt-4 d-none" onClick={handleButtonClick}>
                {isFetching ? <Loader className="on-btn" /> : getButtonLabel()}
              </Button>
            )}
          </Col>
        </Row>
      </div>

      {/* Billing history */}
      <div className="receipt-container">
        <div className="header-wrapper">
          <h2>Billing history</h2>
        </div>
        <div className="billing-history-wrapper">
          <Table
            isLoading={isBillHistoryLoading && !isFetchingNextPage}
            isSubLoading={isFetchingNextPage}
            columns={billingHistoryColumns(handleOpenInvoice)}
            data={billingHistory}
            totalRecords={totalHistory}
            notFoundText="No transaction history"
            showPagination={false}
            customPagination
            handlePageChange={handlePageChange}
            totalPages={totalBillingPages}
          />
        </div>
      </div>

      {/* <div className="mobile-view">
        {isBillHistoryLoading && !isFetchingNextPage ? (
          <Loader />
        ) : (
          <>
            {billingHistory.length === 0 && <div>No transaction history</div>}

            {billingHistory.map((subscription, index) => (
              <Fragment key={subscription.subscription_id || index}>
                <HistoryMobileCard subscription={subscription} />
              </Fragment>
            ))}

            {hasNextPage && (
              <div className="link-more" onClick={handleLoadMoreHistoryClick}>
                Load More
              </div>
            )}
          </>
        )}
      </div> */}
    </PlanAndBillingContainer>
  );
};
